/**
 * Given a meeting or integration reference ID, return the subject ID.
 *
 * If the string is not a complete, valid ID (not just "foo", but also something like "mtg_123",
 * which would be too short), returns undefined.
 */
export function extractSubjectId(s: string): string | undefined {
  const match = s.match(/(mtg_|int_ref_)([a-zA-Z0-9]{19})/)
  if (!match) {
    return undefined
  }

  return match[1] + match[2]
}

export type SubjectId = { meetingId: string } | { intRefId: string }

export function classifySubjectId(s: string): SubjectId {
  return s.startsWith('mtg_') ? { meetingId: s } : { intRefId: s }
}

export function matchesSubjectId(subjectId: SubjectId, s: string | undefined): boolean {
  if (s === undefined) return false
  return 'meetingId' in subjectId ? subjectId.meetingId === s : subjectId.intRefId === s
}
